<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
    >
      <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumn"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.minWidth"
        :align="item.align"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'pushStatus'">
            <el-tag v-if="scope.row.pushStatus === 0" size="mini" type="warning">
              {{ statusOptions[scope.row.pushStatus].label }}
            </el-tag>
            <el-tag v-if="scope.row.pushStatus === 1" size="mini" type="success">
              {{ statusOptions[scope.row.pushStatus].label }}
            </el-tag>
            <el-tag v-if="scope.row.pushStatus === 2" size="mini" type="danger">
              {{ statusOptions[scope.row.pushStatus].label }}
            </el-tag>
            <el-tag v-if="scope.row.pushStatus === 3" size="mini" type="info">
              {{ statusOptions[scope.row.pushStatus].label }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'mdfeStatus'">
            <el-tag v-if="scope.row.mdfeStatus === 1" size="mini" type="success">
              {{ mdfeStatus[scope.row.mdfeStatus].label }}
            </el-tag>
            <el-tag v-if="scope.row.mdfeStatus === 2" size="mini" type="danger">
              {{ mdfeStatus[scope.row.mdfeStatus].label }}
            </el-tag>
            <el-tag v-if="scope.row.mdfeStatus === 3" size="mini" type="info">
              {{ mdfeStatus[scope.row.mdfeStatus].label }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'mdfeKey'">
            <div style="display: flex">
              <div class="ellipsis-key">{{ scope.row.mdfeKey }}</div>
              <div
                v-if="(scope.row.currentMdfeStatus || scope.row.currentMdfeStatus === 0) && scope.row.mdfeStatus !== scope.row.currentMdfeStatus"
                style="width: 20px;cursor: pointer;display: flex;align-items: center;justify-content: end"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('mdfeTranslate.TheStatusOfMdfeHasBeenChangedTo') + mdfeStatus[scope.row.currentMdfeStatus].label + '，' + $t('mdfeTranslate.PleaseFollow')"
                  placement="top"
                >
                  <div style="width: 10px;height: 10px;border-radius: 50%;background:#f56c6c;" />
                </el-tooltip>
              </div>
            </div>
          </div>
          <div v-else>
            {{ scope.row[item.prop] || '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('operationCenter.operate')"
        width="160"
        align="left"
      >
        <template slot-scope="scope">
          <el-button
            v-permit:remove="'btn:invoiceCenter:airlinePushRecords:view'"
            type="text"
            size="mini"
            @click="handleView(scope.row, 5)"
          >
            <span style="color:#409eff !important;">{{ $t('GlobalSetObj.View') }}</span>
          </el-button>
          <!--          v-if="scope.row.pushStatus === 0"-->
          <el-button
            v-if="scope.row.pushStatus === 0"
            v-permit:remove="'btn:invoiceCenter:airlinePushRecords:push'"
            type="text"
            size="mini"
            @click="handleAviationPush(scope.row, 2)"
          >
            <!--航空推送-->
            <span style="color:#409eff !important;">{{ $t('mdfeTranslate.AviationPush') }}</span>
          </el-button>
          <!--          v-if="scope.row.pushStatus === 2"-->
          <el-button
            v-if="scope.row.pushStatus === 2"
            v-permit:remove="'btn:invoiceCenter:airlinePushRecords:rePush'"
            type="text"
            size="mini"
            @click="handleAviationPush(scope.row, 3)"
          >
            <!--重新推送-->
            {{ $t('mdfeTranslate.RePush') }}
          </el-button>
          <el-button
            v-if="scope.row.pushStatus === 1"
            v-permit:remove="'btn:invoiceCenter:airlinePushRecords:cancel'"
            type="text"
            size="mini"
            style="color: #f00;"
            @click="handleView(scope.row, 4)"
          >
            <!--取消-->
            {{ $t('mdfeTranslate.Cancel') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TableColumn',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    statusOptions: {
      type: Object,
      default: () => {
        return {
          0: {
            label: this.$t('mdfeTranslate.PendingPush'), // '待推送',
            value: 0
          },
          1: {
            label: this.$t('mdfeTranslate.Pushed'), // '已推送',
            value: 1
          },
          2: {
            label: this.$t('mdfeTranslate.PushFailed'), // '推送失败',
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Canceled'), // '已取消',
            value: 3
          }
        };
      }
    },
    mdfeStatus: {
      type: Object,
      default: () => {
        return {
          1: {
            label: this.$t('mdfeTranslate.Authorized'),
            value: 1
          },
          2: {
            label: this.$t('collectionCenter.cancelled'),
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Closed'),
            value: 3
          }
        };
      }
    }
  },
  data() {
    return {
      tableColumn: [
        {
          label: this.$t('mdfeTranslate.MDFEKey'), // MDFE秘钥
          prop: 'mdfeKey',
          minWidth: 400
        },
        {
          label: this.$t('mdfeTranslate.PushOrderNumber'), // 推送订单号
          prop: 'pushOrderNumber',
          minWidth: 200
        },
        // {
        //   label: this.$t('collectionCenter.mdfeStatus'), // MDFE状态
        //   prop: 'mdfeStatus',
        //   minWidth: 180
        // },
        {
          label: this.$t('mdfeTranslate.Airline'), // 航空公司
          prop: 'airlineName',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.Origin') + 'IATA', // 始发地
          prop: 'originIata',
          minWidth: 140
        },
        {
          label: this.$t('mdfeTranslate.destination') + 'IATA', // 目的地
          prop: 'destIata',
          minWidth: 140
        },
        {
          label: this.$t('mdfeTranslate.CTeQuantity'), // CTe数量
          prop: 'cteCount',
          minWidth: 100
        },
        {
          label: this.$t('mdfeTranslate.TotalWeight') + '（kg）', // 总重量
          prop: 'totalWeight',
          minWidth: 140
        },
        // {
        //   label: this.$t('orderDetails.TotalNumber'), // 总件数
        //   prop: 'totalNumber',
        //   minWidth: 200
        // },
        {
          label: this.$t('mdfeTranslate.TotalValueOfGoods'), // 货物总价值
          prop: 'totalCargoValue',
          minWidth: 180
        },
        {
          label: this.$t('GlobalSetObj.pushStatus'), // 推送状态
          prop: 'pushStatus',
          minWidth: 160,
          align: 'center'
        },
        {
          label: this.$t('mdfeTranslate.AWBNumber'), // AWB号
          prop: 'airWaybillNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          label: this.$t('mdfeTranslate.Pusher'), // 推送人
          prop: 'operatorUserName',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.PushTime'), // 推送时间
          prop: 'pushTime',
          minWidth: 180
        }
      ]
    };
  },
  methods: {
    // 详情
    handleView(row, type) {
      console.log(row);
      this.$emit('handleView', row, type);
    },
    // 航空推送
    handleAviationPush(row, type) {
      console.log(row);
      this.$emit('handleFlightPush', row, type);
    }
  }
};
</script>

<style scoped>
.ellipsis-key {
  width: calc(100% - 25px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
</style>
